import { sortStringWithSortType } from '@/utils';
const getters = {
    getterShareInfoTotalLength: ({ shareInfo }) => (shareInfo
        ? shareInfo.formattedShares.length
            + shareInfo.formattedUnShares.length
            + shareInfo.formattedSharesOfOthers.length
        : 0),
    getterShareStoreListLength: ({ shareStoreList }) => shareStoreList.length,
    getterSelectedRowShareInfo: ({ selectedRowShareInfo }) => selectedRowShareInfo,
    getterShareInfoStatusType: ({ filterOption }) => filterOption.shareInfoStatusType,
    getterSearchWordValue: ({ filterOption }) => filterOption.searchWord.value,
    getterShareInfoList: ({ shareInfo, shareInfoSortOptions }) => {
        if (!shareInfo) {
            return [];
        }
        const { field, value } = shareInfoSortOptions[0];
        const { formattedShares, formattedUnShares, formattedSharesOfOthers, } = shareInfo;
        const sortCondition = (a, b) => sortStringWithSortType(a[field], b[field], value);
        const sortedShares = [
            ...formattedShares,
        ].sort(sortCondition);
        const sortedUnShares = [
            ...formattedUnShares,
        ].sort(sortCondition);
        const sortedSharesOfOthers = [
            ...formattedSharesOfOthers,
        ].sort(sortCondition);
        return [
            ...sortedShares,
            ...sortedUnShares,
            ...sortedSharesOfOthers,
        ];
    },
    getterShareStoreList: ({ shareStoreList }) => shareStoreList,
    getterShareInfoSortOptionValue: ({ shareInfoSortOptions }) => shareInfoSortOptions[0].value,
};
export default getters;
